import admissionConfig from './components/config.vue';

// Конфигуратор остаётся корневым экраном раздела; переключение предметных
// областей выполняется фиксированным меню внутри компонента без смены URL.
export default {
  routes: [
    {
      path: '/',
      component:admissionConfig,
      name:'admissionConfig'
    }
  ]
};
